/**
 * 管理图层url
 * @author zhb
 */

let mapUrl = {
  //普通电子地图
  NMAP:
    "http://140.210.143.7/map_server/{z}/{x}/{y}.png",

  //卫星地图
  WMAP:
    "http://58.215.175.122:7080/PBS/rest/services/GoogleHybrid/MapServer/tile/{z}/{y}/{x}",
  //海图
  // SMAP: "http://m11.shipxy.com/tile.c?l=Na&m=o&z={z}&y={y}&x={x}",
  // SMAP: "https://m12.shipxy.com/tile.c?l=Na&m=o&z={z}&y={y}&x={x}",
  SMAP: "https://static.hifleet.com/autical_chart/osm_cn/osm/{z}/{y}/{x}.png",

  //经纬网格
  LLMAP:
    "http://58.215.175.29/ReadearthRest/JWW/2046/20461231/20461231235959_JWW/MapServer/tile/{z}/{y}/{x}",
  //经济区(arcgis server
    // ENCMAP: "http://119.3.104.235:7081/PBS/rest/services/ECONOMICZONE/MapServer/tile/{z}/{y}/{x}",
  ENCMAP: "http://119.3.104.235:6080/arcgis/rest/services/eez/MapServer",
  //渔船
  SHIP: "http://www.hifleet.com/getdotshipimage.do?x={x}&y={y}&z={z}&r=2015739",
  // SHIP: "http://47.100.49.112:18080/pbs/rest/services/shipos/MapServer/tile/{z}/{y}/{x}",

  //渔场
  FISH: "http://119.3.104.235:6080/arcgis/rest/services/fisharea/MapServer",
  //印度洋
  RFBSIOFA: "http://119.3.104.235:6080/arcgis/rest/services/rfbsiofa/MapServer",
  //北冰洋
  RFBNPFC: "http://119.3.104.235:6080/arcgis/rest/services/rfbnpfc/MapServer",
  // RFBNPFC: "http://192.168.1.204:81/api/rest/services/SXYD/GYYQ/MapServer/export?key=soatest",
  //等深线
  // DEPTHLINE: "http://localhost:6080/arcgis/rest/services/depthcontour/MapServer",
  //等深线
  // DEPTHLINE: "http://localhost:8080/geoserver/gwc/service/wmts",
  DEPTHLINE: "http://47.100.49.112:18086/geoserver/gwc/service/wmts",
  // http://localhost:8080/geoserver/gwc/service/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=vectortile:depth_1000_z&STYLE=&TILEMATRIX=EPSG:4326:10&TILEMATRIXSET=EPSG:4326&FORMAT=application/vnd.mapbox-vector-tile&TILECOL=211&TILEROW=701
};
export default mapUrl;



// WEBPACK FOOTER //
// ./src/store/mapurl.js